import axios from "../../utils/axios";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  payments: [],
};

const paymentsSlice = createSlice({
  name: "payments",
  initialState,
  reducers: {
    setPayments(state, action) {
      state.payments = action.payload;
    },
    addPayment(state, action) {
      const newPayment = action.payload;
      return {
        ...state,
        payments: [...state.payments, newPayment],
      };
    },
  },
});

export function registerPayment({ data }) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const impersonationToken =
      window.localStorage.getItem("impersonationToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/payments`,
        data,
        {
          headers: {
            Authorization: `Bearer ${
              impersonationToken ? impersonationToken : accessToken
            }`,
          },
        }
      );
      dispatch(paymentsSlice.actions.addPayment(response.data.data));
      return Promise.resolve(response.data.message);
    } catch (error) {
      return Promise.reject(error.message);
    }
  };
}

export default paymentsSlice.reducer;
